module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/step4_bg_left-9dda4589feea55fcbcd591ef3ca85350.png";